import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_RTK_REQUEST = 'GET_RTK_REQUEST';
export const GET_RTK_SUCCESS = 'GET_RTK_SUCCESS';
export const GET_RTK_FAILURE = 'GET_RTK_FAILURE';

function requestGetRtk() {
  return {
    type: GET_RTK_REQUEST,
    isRtkLoading: true,
    rtk: null,
    rtkError: null
  };
}

function receiveGetRtk(rtk) {
  return {
    type: GET_RTK_SUCCESS,
    isRtkLoading: false,
    rtk,
    cicReviewState: rtk.review,
    workflowState: rtk.workflow,
    rtkError: null
  };
}

function rejectGetRtk(rtkError) {
  return {
    type: GET_RTK_FAILURE,
    isRtkLoading: false,
    rtkError
  };
}

export function getRtk(id) {
  return (dispatch) => {
    dispatch(requestGetRtk());

    const promise = () => ApiService
      .getRtk(id)
      .then((response) => {
        dispatch(receiveGetRtk(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetRtk, true));
        }
      });
    return promise();
  };
}
